import {Directive, ElementRef, HostListener, Input} from '@angular/core';
import * as $ from 'jquery';
@Directive({
    selector: '[resizeSearch]'
})
export class ResizeSearchDirective {
    @Input() resizeSearch: any;

    constructor(private elRef: ElementRef) {}

    ngDoCheck() {
        let el: any = $(this.elRef.nativeElement);
        let height: number = el.innerHeight() - 325;
        let block = $('.accordion-body', el);

        block.css('min-height', height);
        block.css('max-height', height);
    }
}